import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white" aria-label="Site footer">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <div className="text-center sm:text-left">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} VECTOR Athletic Performance System
            </p>
            <p className="mt-1 text-xs text-gray-400 max-w-md">
              Online athletic performance coaching for athletes in Kildare, Dublin, and across Ireland.
            </p>
          </div>

          <a
            href="https://www.racketsoftware.ie"
            target="_blank"
            rel="noreferrer"
            className="text-sm font-medium text-gray-600 hover:text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded"
            aria-label="Powered by Racket Software (opens in a new tab)"
          >
            Powered by <span className="font-semibold">Racket Software</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

